import {ClickAwayListener, Popper} from "@mui/material";
import Paper from "@mui/material/Paper";
import React from "react";
import {Message} from "../../lib/stores/MessageStore";
import {ReactionPanel} from "./ReactionPanel";

interface ReactionPanelProps {
    message: Message,
    open: boolean,
    anchorEl: React.MutableRefObject<HTMLHtmlElement>,
    onClose: () => any,
}

export function DesktopReactionPanel({message, open, anchorEl, onClose}: ReactionPanelProps) {

    return <Popper
            sx={{
                maxHeight: "200px",
                overflow: "auto",
            }}
            modifiers={[
                {
                    name: "offset",
                    options: {
                        offset: [0, 5],
                    },
                },
            ]}
            open={open}
            anchorEl={anchorEl?.current}
            role={undefined}
            placement="left-start"
            style={{
                width: "240px",
            }}
    >
        <Paper
                sx={{overflow: "hidden"}}
        >
            <ClickAwayListener onClickAway={onClose}>
                <ReactionPanel message={message} onClose={onClose}/>
            </ClickAwayListener>
        </Paper>
    </Popper>
}
